import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { MenuItem, Paper, TextField } from 'material-ui';
import SelectField from 'material-ui/SelectField';
import { createMonthMenuItems } from 'src/utils/helpers';
import moment from 'moment';
import { asyncRequest, Entities, Projection, TOMCAT_URL } from 'src/common';
import AdminOperatorSupportBillingOperatorAddTaskForm from 'src/components/admin/operator-support-billing/components/admin-operator-support-billing-add-task-form';
import autoBind from 'react-autobind/src/autoBind';
import AdminOperatorSupportBillingTaskList from 'src/components/admin/operator-support-billing/components/admin-operator-support-billing-task-list';

class AdminOperatorSupportBillingOperatorSelection extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            selectedOperator: null,
            searchTerm: '',
            selectedValue: null,
            filteredOptions: this.props.busCompanies || [],
            open: false,
            fetchedOperatorInvoiceItems: [],
            selectedMonth: moment().startOf('month').format('X'),
        };
    }

    handleInputChange = event => {
        const searchTerm = event.target.value;
        const { busCompanies } = this.props;
        let filteredOptions;
        if (searchTerm && busCompanies) {
            filteredOptions = busCompanies.filter(option =>
                option.companyName.toLowerCase().includes(searchTerm.toLowerCase()),
            );
        } else {
            filteredOptions = busCompanies;
        }
        this.setState({ searchTerm, open: true, filteredOptions });
    };

    handleBlur = () => {
        setTimeout(() => this.setState({ open: false }), 100);
    };

    handleSuggestionClick = option => {
        this.setState({
            searchTerm: option.companyName,
            selectedValue: option,
            open: false,
            filteredOptions: [],
        });

        if (this.props.onOperatorSelect) {
            this.props.onOperatorSelect(option);
        }
        this.fetchOperatorSupportItems(option, this.state.selectedMonth);
    };

    handleSubmit(data) {
        data.busCompanyId = this.state.selectedValue.id;
        this.createNewSupportOperatorTask(data).then();
    }

    async createNewSupportOperatorTask(data) {
        const { t } = this.props;
        await asyncRequest({
            method: 'POST',
            endpoint: `${TOMCAT_URL}api/${Entities.OPERATOR_SUPPORT_BILLING.repository}/create`,
            body: {
                ...data,
            },
        })
            .then(response => {
                const selectedMonth = moment.unix(this.state.selectedMonth);

                const formattedMonth = selectedMonth.format('YYYY-MM-DD');
                if (response)
                    this.props.search(
                        Entities.OPERATOR_SUPPORT_BILLING,
                        `getOperatorSupportInvoiceItems?companyId=${this.state.selectedValue.id}&monthYear=${formattedMonth}`,
                        0,
                        Projection.FULL,
                        true,
                    );

                this.props.addNotification(
                    t('common_phrases.success'),
                    t('invoice.success_support_task'),
                    'success',
                    'tr',
                );
            })
            .catch(error => {
                this.props.addErrorNotification({ code: error.status, message: error.statusText });
            });
    }

    fetchOperatorSupportItems(option, date) {
        if (option == null) return;

        const selectedMonth = moment.unix(date);

        const formattedMonth = selectedMonth.format('YYYY-MM-DD');

        this.props.search(
            Entities.OPERATOR_SUPPORT_BILLING,
            `getOperatorSupportInvoiceItems?companyId=${option.id}&monthYear=${formattedMonth}`,
            0,
            Projection.FULL,
            true,
        );
    }

    render() {
        const { searchTerm, filteredOptions, open } = this.state;
        const { t, operatorSupportBillingItems, deleteById } = this.props;

        return (
            <>
                <div className="row">
                    <div className="col-md-4">
                        <TextField
                            label={t('invoice.choose_operator')}
                            floatingLabelText={t('invoice.choose_operator')}
                            value={searchTerm}
                            onChange={this.handleInputChange}
                            onFocus={() => this.setState({ open: true })}
                            onBlur={this.handleBlur}
                            fullWidth
                        />
                        {open && filteredOptions.length > 0 && (
                            <Paper style={{ width: 500, height: 200, overflow: 'auto' }}>
                                {filteredOptions.map(option => (
                                    <MenuItem
                                        key={option.companyName}
                                        onClick={() => this.handleSuggestionClick(option)}
                                        component="div">
                                        {option.companyName}
                                    </MenuItem>
                                ))}
                            </Paper>
                        )}
                    </div>
                    <div className="col-md-4">
                        <SelectField
                            value={this.state.selectedMonth}
                            onChange={(event, index, value) => {
                                this.setState({
                                    selectedMonth: value,
                                });
                                this.fetchOperatorSupportItems(this.state.selectedValue, value);
                            }}
                            floatingLabelText={t('invoice.month')}
                            fullWidth={true}
                            hintText={t('invoice.select_month')}
                            floatingLabelFixed={true}>
                            {[<MenuItem key={-1} value={false} primaryText={t('common_phrases.all')} />].concat(
                                createMonthMenuItems(),
                            )}
                        </SelectField>
                    </div>
                </div>
                {this.state.selectedValue && (
                    <div className="row">
                        <div className="col-md-12">
                            <AdminOperatorSupportBillingOperatorAddTaskForm
                                t={t}
                                onSubmit={this.handleSubmit}
                                selectedMonth={this.state.selectedMonth}
                            />
                        </div>

                        <div className="col-md-12">
                            <AdminOperatorSupportBillingTaskList
                                t={t}
                                operatorSupportBillingItems={operatorSupportBillingItems}
                                deleteById={deleteById}
                                selectedMonth={this.state.selectedMonth}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(AdminOperatorSupportBillingOperatorSelection);
